import React, { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "./../firebase-config";
import { useParams } from "react-router-dom";
import Spinner from "../components/Spinner";

export default function SingleCourse() {
  const { id } = useParams();

  const [courseDataData, setCourseDataData] = useState(null);
  const courseDataDocRef = doc(db, "courses-data", id);

  const getCourseDataData = async () => {
    const data = await getDoc(courseDataDocRef);
    setCourseDataData(data.data());
    document.title = "Dr. Nithin M | Courses | " + data.data()["title"];
  };

  useEffect(() => {
    getCourseDataData();
  }, [id]);

  return (
    <section class="blog-section">
      {courseDataData ? (
        <>
          <div>
            <h2 class="section-title">{courseDataData["title"]}</h2>
          </div>
          {/* <div className='container'> */}
          <div className="row">
            <div className="col-md-12" style={{ textAlign: "center" }}>
              <img
                className="img-fluid"
                src={courseDataData["image"]}
                width={"50%"}
              />
            </div>
            <div
              className="col-md-12"
              style={{ textAlign: "justify", marginTop: "20px" }}
            >
              <p>{courseDataData["desc"]}</p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <table class="table table-striped table-responsive">
                <thead>
                  <tr style={{'textAlign': 'justify'}}>
                    <th scope="col">#</th>
                    <th scope="col">Title</th>
                    <th scope="col">Description</th>
                    <th scope="col">YouTube Link</th>
                    <th scope="col">Document Link</th>
                  </tr>
                </thead>
                <tbody>
                  {courseDataData["data"].length > 0 ? (
                    courseDataData["data"].map((session, i) => {
                      return (
                        <tr>
                          <th scope="row">{i + 1}</th>
                          <td>{session["title"]}</td>
                          <td>{session["desc"]}</td>
                          <td>
                            <a href={session["ytLink"]} target={"_blank"}>
                              {session["ytLink"]}
                            </a>
                          </td>
                          <td>{session["docLink"]}</td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colspan="5" style={{ textAlign: "center" }}>
                        No Data Found
                      </td>
                    </tr>
                  )}
                  {/*  */}
                </tbody>
              </table>
            </div>
          </div>
          {/* </div> */}
        </>
      ) : (
        <Spinner />
      )}
    </section>
  );
}
